export default __webpack_public_path__ + "static/media/img2.5f5d19ad.png";